var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"document-preview-modal","title":_vm.previewFile.name,"size":"xl","hide-footer":""}},[(_vm.isLoading)?_c('div',{staticClass:"preview-iframe"},[_c('LmComponentLoading')],1):_c('iframe',{staticClass:"preview-iframe",attrs:{"src":_vm.previewFile.src,"frameborder":"0","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }